module.exports = __webpack_public_path__ + "static/media/logo-ecommerce.007003f7.png";